import type { FeatureFlags } from "$global-providers/feature-flags-provider/provider";
import Box from "@material-ui/core/Box";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { useState } from "react";

const useStyles = makeStyles({
  wrapper: {
    width: "100%",
    height: "100%",
  },
  header: {
    paddingBottom: 0,
  },
  content: {
    paddingTop: 0,
  },
  scrollable: {
    marginTop: 10,
    display: "flex",
    flexDirection: "column",
    maxHeight: 250,
    overflowY: "scroll",
  },
  input: {
    width: "100%",
  },
  checkbox: {
    padding: 2,
  },
  formLabel: {
    marginLeft: 0,
  },
});

export interface Props {
  featureFlags: FeatureFlags;
  onFeatureFlagChange: (flags: FeatureFlags) => void;
}

export const FeatureFlagsPanel: FC<Props> = ({
  featureFlags,
  onFeatureFlagChange,
}) => {
  const [filter, setFilter] = useState(
    sessionStorage.getItem("dev-tools.featureFlagWidget.filter") || "",
  );

  const classes = useStyles();

  return (
    <Card className={classes.wrapper} elevation={2}>
      <CardHeader title="Feature Flags" className={classes.header} />
      <CardContent className={classes.content}>
        <TextField
          className={classes.input}
          label="Filter"
          value={filter}
          autoFocus
          onChange={(e) => {
            const value = e.target.value.toLowerCase();
            setFilter(value);
            sessionStorage.setItem("dev-tools.featureFlagWidget.filter", value);
          }}
        />
        <Box className={classes.scrollable}>
          {Object.entries(featureFlags)
            .filter(([flagName]) => flagName.toLowerCase().includes(filter))
            .sort((a, b) => a[0].localeCompare(b[0]))
            .map(([flagName, flagValue]) => (
              <FormControlLabel
                key={flagName}
                className={classes.formLabel}
                control={
                  <Checkbox
                    color="primary"
                    className={classes.checkbox}
                    checked={Boolean(flagValue)}
                    onChange={() =>
                      onFeatureFlagChange({
                        [flagName]: !flagValue,
                      })
                    }
                    name={flagName}
                  />
                }
                label={flagName}
              />
            ))}
        </Box>
      </CardContent>
    </Card>
  );
};
